// extracted by mini-css-extract-plugin
export default {"LandingPanelContainer":"DwKCYoxf","LandingPageCenterText":"Hw9RpD6V","LandingSubPanel":"hdbgzL9p","IconStyling":"jdLLdmol"};